<div class="p-3">
    <div class="mb-7 mt-6">
        <div class="flex h-[9rem] justify-center md:justify-start">
            <img
                class="h-full dark:filter-yellow"
                alt="Card image"
                src="{{ assetsPath$ | async }}/img/cards/{{
                    card?.cardType === cardType.EMV ? card?.scheme : 'card-template'
                }}.png" />
        </div>
    </div>

    <div class="border-[rgba(0, 0, 0, 0.1)] mb-4 box-border border-b border-solid dark:border-contrast-yellow"></div>

    <div class="grid grid-cols-2">
        <div class="mb-3">
            <p class="text-xs font-semibold text-[#838383] dark:text-contrast-yellow">{{ 'CARD_NAME' | translate }}</p>
            <p class="break-words pr-1 font-bold">
                {{ card?.cardType === cardType.EMV && !card?.name ? card?.scheme : card?.name }}
            </p>
        </div>

        <div class="mb-3" *ngIf="!card?.blocked && card?.cardType !== cardType.EMV">
            <p class="text-xs font-semibold text-[#838383] dark:text-contrast-yellow">
                {{ 'MONEY_BALANCE' | translate }}
            </p>
            <p class="text-xl font-bold">
                {{ card?.balance | moneyFormat }}&nbsp;{{ appStartupService.getCurrency() | translate }}
            </p>
        </div>

        <div>
            <p class="text-xs font-semibold text-[#838383] dark:text-contrast-yellow">
                {{ 'CARD_NUMBER' | translate }}
            </p>
            <p>
                {{ card?.cardNumber }}
            </p>
        </div>

        <div *ngIf="showDiscountGroups">
            <p class="text-xs font-semibold text-[#838383] dark:text-contrast-yellow">
                {{ 'RELATED_CARD_DETAIL_DISCOUNT' | translate }}
            </p>
            <ng-container *ngIf="discountGroupsLoaded">
                <ng-container *ngIf="discountGroups?.length > 0; else adultGroup">
                    <p *ngFor="let group of discountGroups">
                        {{ group | translateObjectField: 'name' : locale }}
                    </p>
                </ng-container>

                <ng-template #adultGroup>
                    <p>{{ 'ADULT' | translate }}</p>
                </ng-template>
            </ng-container>
        </div>
    </div>
</div>
